import { circlesKeys } from './keys';
import {
	addCircle,
	AddCircleRequest,
	addParticipants,
	deleteCircle,
	removeParticipants,
	ParticipantsRequest,
	RemoveParticipantRequest,
	UpdateCircleRequest,
	updateCircle,
} from './api';
import { QueryClient } from '@tanstack/react-query';
import { Circle } from '../../models/circle';

export const setDefaultCircleMutations = (queryClient: QueryClient) => {
	// we need a default mutation function so that paused mutations can resume after a page reload
	queryClient.setMutationDefaults(circlesKeys.add(), {
		mutationFn: async (circle: AddCircleRequest) => {
			// to avoid clashes with our optimistic update when an offline mutation continues
			await queryClient.cancelQueries({
				queryKey: circlesKeys.add(),
			});
			return await addCircle(circle);
		},
	});

	// we need a default mutation function so that paused mutations can resume after a page reload
	queryClient.setMutationDefaults(circlesKeys.update(), {
		mutationFn: async (circle: UpdateCircleRequest) => {
			// to avoid clashes with our optimistic update when an offline mutation continues
			await queryClient.cancelQueries({
				queryKey: circlesKeys.update(),
			});
			if (circle.circleId) {
				return await updateCircle(circle);
			}
		},
	});

	// we need a default mutation function so that paused mutations can resume after a page reload
	queryClient.setMutationDefaults(circlesKeys.delete(), {
		mutationFn: async (circle: Circle) => {
			// to avoid clashes with our optimistic update when an offline mutation continues
			await queryClient.cancelQueries({
				queryKey: circlesKeys.delete(),
			});
			if (circle.id) {
				await deleteCircle(circle.id);
			}
		},
	});

	// we need a default mutation function so that paused mutations can resume after a page reload
	queryClient.setMutationDefaults(circlesKeys.updateParticipants(), {
		mutationFn: async (participant: ParticipantsRequest) => {
			// to avoid clashes with our optimistic update when an offline mutation continues
			await queryClient.cancelQueries({
				queryKey: circlesKeys.updateParticipants(),
			});
			return await addParticipants(participant);
		},
	});

	// we need a default mutation function so that paused mutations can resume after a page reload
	queryClient.setMutationDefaults(circlesKeys.removeParticipants(), {
		mutationFn: async ({ circleId, participantId }: RemoveParticipantRequest) => {
			// to avoid clashes with our optimistic update when an offline mutation continues
			await queryClient.cancelQueries({
				queryKey: circlesKeys.removeParticipants(),
			});
			if (circleId && participantId) {
				await removeParticipants({ circleId, participantId });
			}
		},
	});
};
